export const defaultLocale = 'en' as const
export const locales = ['en', 'es', 'fr'] as const
export type Locale = (typeof locales)[number]

export function isValidLocale(value: string): value is Locale {
  return locales.includes(value as Locale)
}
